
export enum MadlenContentTypeEnums {
    Pending = 0,
    Sended = 1,
    Failed = 2,
}